"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toValue = exports.toNativeValue = exports.parseNativeEvent = void 0;
const moment_1 = __importDefault(require("moment"));
const dateTime_1 = require("../../utils/dateTime");
const dateTimeFormat_1 = require("../../utils/dateTimeFormat");
const translation_1 = require("./translation");
const parseStringEvent = (event) => event.target.value;
const parseBooleanEvent = (event) => (('checked' in event.target) && event.target.checked);
const parseNativeEvent = (event, type) => {
    if (type === 'number' || type === 'string' || type === 'date') {
        const nativeValue = parseStringEvent(event);
        return nativeValue;
    }
    if (type === 'boolean') {
        const nativeValue = parseBooleanEvent(event);
        return nativeValue;
    }
    return undefined;
};
exports.parseNativeEvent = parseNativeEvent;
const toNativeValue = (value, type) => {
    if (type === 'number') {
        const nativeValue = `${value !== null && value !== void 0 ? value : ''}`;
        return nativeValue;
    }
    if (type === 'string') {
        const nativeValue = value !== null && value !== void 0 ? value : '';
        return nativeValue;
    }
    if (type === 'date') {
        const nativeValue = value ? (0, moment_1.default)(value, dateTimeFormat_1.DATE_OUTPUT_FORMAT).format(dateTimeFormat_1.DATE_FORMAT) : '';
        return nativeValue;
    }
    if (type === 'boolean') {
        const nativeValue = value !== null && value !== void 0 ? value : false;
        return nativeValue;
    }
    return undefined;
};
exports.toNativeValue = toNativeValue;
const hasValue = (value) => {
    if ([undefined, null, ''].includes(value))
        return false;
    return true;
};
const toValue = (nativeValue, type, formatMessage) => {
    if (type === 'number') {
        if (!hasValue(nativeValue)) {
            return {};
        }
        const value = Number(nativeValue);
        if (Number.isNaN(value)) {
            const nativeError = formatMessage(translation_1.validationMessages.number);
            return { nativeError };
        }
        return { value };
    }
    if (type === 'string') {
        const value = nativeValue;
        return { value };
    }
    if (type === 'date') {
        if (!hasValue(nativeValue)) {
            return {};
        }
        const valueDate = (0, dateTime_1.parseInputDate)(nativeValue);
        if (!valueDate) {
            const nativeError = formatMessage(translation_1.validationMessages.date, {
                dateFormat: dateTimeFormat_1.DATE_FORMAT,
            });
            return { nativeError };
        }
        const value = valueDate.format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
        return { value };
    }
    if (type === 'boolean') {
        const value = nativeValue;
        return { value };
    }
    return {};
};
exports.toValue = toValue;
//# sourceMappingURL=nativeValue.js.map